import { render, staticRenderFns } from "./PostSidebar.vue?vue&type=template&id=04b06528&scoped=true&"
import script from "./PostSidebar.vue?vue&type=script&lang=js&"
export * from "./PostSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b06528",
  null
  
)

export default component.exports